import styled from 'styled-components';

export const CheckboxLabel = styled.label`
    display: flex;
    width: 20px;
    height: 20px;
    padding: 3px;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    border: ${props => props.checked ? '1px solid #17B26A' : '1px solid #D0D5DD'};
    background: ${props => props.checked ? '#ECFFD9' : '#FFF'};
    cursor: ${props => props.readOnly ? 'default' : 'pointer'};
    transition: all 0.2s ease;
    margin: 0;
    box-sizing: border-box;
    flex-shrink: 0;
    position: relative;
`;

export const CheckboxInput = styled.input`
    position: absolute;
    opacity: 0;
    width: 20px;
    height: 20px;
    margin: 0;
    padding: 0;
    cursor: ${props => props.readOnly ? 'default' : 'pointer'};
    z-index: 1;
`;

export const CheckIcon = styled.svg`
    pointer-events: none;
`;

